import React from 'react'
import { Route, Switch } from 'react-router-dom'
import ButtonsPage from '../components/Buttons'
import Selects from '../components/Selects'
import Autocomplete from '../components/Autocomplete'
import Inputs from '../components/Inputs'
import Checkboxes from '../components/Checkboxes'

const Form = (props: any) => {
  const { path } = props.match
  return (
    <Switch>
      <Route exact path={`${path}`} />
      <Route path={`${path}/buttons`}>
        <ButtonsPage />
      </Route>
      <Route path={`${path}/selects`}>
        <Selects />
      </Route>
      <Route path={`${path}/autocomplete`}>
        <Autocomplete />
      </Route>
      <Route path={`${path}/inputs`}>
        <Inputs />
      </Route>
      <Route path={`${path}/checkboxes`}>
        <Checkboxes />
      </Route>
    </Switch>
  )
}

export default Form
